import { hasAcceptedToAll } from '../gdpr/util';
import { loadPermutiveScript } from './load-permutive-script';
import { addDurationMedia } from '../duration-media/add-duration-media'

// 兜底：页面加载时已同意
function checkAndLoadPermutiveOnInit(window) {
    if (window.__tcfapi) {
        window.__tcfapi('getTCData', 2, (tcData, success) => {
            if (success && tcData.eventStatus !== 'cmpishown') {
                const { vendor, purpose } = tcData;
                const acceptedToAll = hasAcceptedToAll(vendor.consents, purpose.consents);
                if (acceptedToAll) {
                    loadPermutiveScript();
                    setPermutiveConsentOnly(window);
                    // 同样依赖授权，也与permutive一起引入
                    addDurationMedia(window);
                }
            }
        });
    }
}

// 监听 consent 变化
function listenConsentAndLoadPermutive(window) {
    if (window.__tcfapi) {
        window.__tcfapi('addEventListener', 2, (tcData, success) => {
            if (success && tcData.eventStatus !== 'cmpishown') {
                const { vendor, purpose } = tcData;
                const acceptedToAll = hasAcceptedToAll(vendor.consents, purpose.consents);
                if (acceptedToAll) {
                    loadPermutiveScript();
                    setPermutiveConsentOnly(window);
                    // 同样依赖授权，也与permutive一起引入
                    addDurationMedia(window);
                }
            }
        });
    }
}

// 只负责设置 permutive.consent，不负责加载脚本
// 监听 consent 变化时，应当先加载 Permutive 脚本，再设置 consent。否则如果脚本还没加载，window.permutive.consent 其实是无效的。
function setPermutiveConsentOnly(window) {
    if (!window.__tcfapi) return;
    window.__tcfapi('addEventListener', 2, (tcData, success) => {
        const { eventStatus, vendor, purpose } = tcData;
        if (success && eventStatus !== 'cmpishown') {
            const acceptedToAll = hasAcceptedToAll(vendor.consents, purpose.consents);
            if (window.permutive) {
                if (acceptedToAll) {
                    window.permutive.consent({ opt_in: true, token: 'OK' });
                } else {
                    window.permutive.consent({ opt_in: false });
                }
            }
        }
    });
}

// 对外暴露的初始化方法
export function initPermutiveWithConsent(window) {
    checkAndLoadPermutiveOnInit(window);
    listenConsentAndLoadPermutive(window);
}
